export default __webpack_public_path__ + "static/media/brighthive-logo-medium.882cceb1.svg";